var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowLong1 = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 40,
    viewBox: "0 0 85 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 36H0V36.5H0.5V36ZM84.8536 36.3536C85.0488 36.1583 85.0488 35.8417 84.8536 35.6464L81.6716 32.4645C81.4763 32.2692 81.1597 32.2692 80.9645 32.4645C80.7692 32.6597 80.7692 32.9763 80.9645 33.1716L83.7929 36L80.9645 38.8284C80.7692 39.0237 80.7692 39.3403 80.9645 39.5355C81.1597 39.7308 81.4763 39.7308 81.6716 39.5355L84.8536 36.3536ZM0.5 0H0V36H0.5H1V0H0.5ZM0.5 36V36.5H84.5V36V35.5H0.5V36Z",
    fill: "#404040"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLong1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-long-1.6f1f095f.svg";
export { ForwardRef as ReactComponent };